var map = {
	"./CHINA.svg": 3171,
	"./DELAWARE.svg": 460,
	"./GREECE.svg": 7079,
	"./HK.svg": 1589,
	"./T.svg": 6136,
	"./TURKEY.svg": 4236
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5803;